// Third-party
import React from 'react';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { COMPARISON_ITEM_TYPES, FUND_SOURCE } from '../../../../utils/constants';
import { getYieldToMaturityAsAtDates } from '../../../../utils/disclaimers/comparison';

// Components
import DatesDisclaimer from './DatesDisclaimer';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

export default function ({ items, locale, showItemNames = true }: Props) {
  const fundataItems = items.filter(
    i =>
      i.type !== COMPARISON_ITEM_TYPES.STOCK &&
      i.type !== COMPARISON_ITEM_TYPES.BENCHMARK &&
      (((i.type === COMPARISON_ITEM_TYPES.PORTFOLIO || i.type === COMPARISON_ITEM_TYPES.GROUP) && portfolioHasFundata(i)) ||
        (i.characteristics?.yieldToMaturity && i.characteristics.yieldToMaturity.source === 'FUNDATA')) &&
      !!i.disclaimers &&
      !i.disclaimers[DISCLAIMER_KEYS.FUND_FIXED_INCOME_METRICS_NOT_APPLICABLE] &&
      !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_FIXED_INCOME_METRICS_NOT_APPLICABLE],
  );

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.YieldToMaturity', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getYieldToMaturityAsAtDates(fundataItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
}

function portfolioHasFundata(item: ComparisonItem) {
  const fundataHoldings = item.holdings.filter(holding => holding.metrics?.yieldToMaturity?.source === FUND_SOURCE.FUNDATA);
  if (fundataHoldings.length > 0) {
    return true;
  }
  return false;
}
